export const toCamelCase = function (sentenceCaseString) {
  return sentenceCaseString.replace(/\s+(.)/g, function (match, group) {
    return group.toUpperCase();
  });
};
